import { z } from 'zod';
import { isoDateTimeSchema, uuidSchema } from './common.js';
import { emailSchema } from './auth.js';
import { householdRoleSchema, invitationStatusSchema } from './enums.js';
import { publicUserSchema } from './users.js';
export const householdMemberSchema = z.object({
    user: publicUserSchema,
    role: householdRoleSchema,
    joinedAt: isoDateTimeSchema,
});
export const householdSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    ownerId: uuidSchema,
    myRole: householdRoleSchema,
    memberCount: z.number().int(),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
export const householdDetailSchema = householdSchema.extend({
    members: z.array(householdMemberSchema),
    pendingInvitations: z.array(z.object({
        id: uuidSchema,
        email: z.string(),
        role: householdRoleSchema,
        status: invitationStatusSchema,
        expiresAt: isoDateTimeSchema,
        createdAt: isoDateTimeSchema,
    })),
});
export const householdWriteSchema = z.object({
    name: z.string().trim().min(1).max(120),
});
export const inviteMemberRequestSchema = z.object({
    email: emailSchema,
    role: householdRoleSchema.exclude(['OWNER']).default('EDITOR'),
});
export const invitationResponseSchema = z.object({
    id: uuidSchema,
    /** Only returned to the inviter while mail delivery is disabled, so the link can be shared manually. */
    inviteUrl: z.string().nullable(),
});
export const acceptInvitationRequestSchema = z.object({
    token: z.string().min(16).max(512),
});
export const invitationPreviewSchema = z.object({
    householdName: z.string(),
    invitedBy: publicUserSchema,
    role: householdRoleSchema,
    email: z.string(),
    expiresAt: isoDateTimeSchema,
    status: invitationStatusSchema,
});
export const updateMemberRoleRequestSchema = z.object({
    role: householdRoleSchema.exclude(['OWNER']),
});
export const transferOwnershipRequestSchema = z.object({
    newOwnerUserId: uuidSchema,
});
//# sourceMappingURL=households.js.map